import { createAndDownloadExcel, generateExcelFilename } from './excelExportUtils';

/**
 * Alarm geçmiş verilerini Excel formatında indirir
 *
 * @param {Array} rows - DataGrid satırları
 * @param {Array} columns - DataGrid kolonları
 * @param {string} nodeId - Node ID
 */
export const exportAlarmHistory = (rows, columns, nodeId) => {
  const fileName = generateExcelFilename('Alarm_Gecmisi', nodeId || 'Node');

  return createAndDownloadExcel(
    rows,
    columns,
    'Alarm Geçmişi',
    fileName,
    {
      maxColumnWidth: 60 // description için daha geniş
    }
  );
};
